import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { CoachProfileShell } from '../components/ProfileShell';

export default function CoachSocialPage() {
  const { user, API_URL } = useAuth();
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const [personalStatement, setPersonalStatement] = useState('');
  const [youtubeHandle, setYoutubeHandle] = useState('');
  const [twitterHandle, setTwitterHandle] = useState('');
  const [instagramHandle, setInstagramHandle] = useState('');
  const [tiktokHandle, setTiktokHandle] = useState('');
  const [snapchatHandle, setSnapchatHandle] = useState('');
  const [facebookHandle, setFacebookHandle] = useState('');
  const [linkedinHandle, setLinkedinHandle] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [socialContact, setSocialContact] = useState([]);

  const getAxiosConfig = () => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const response = await axios.get(`${API_URL}/coaches/profile`, getAxiosConfig());
      if (response.data) {
        setPersonalStatement(response.data.personal_statement || '');
        setYoutubeHandle(response.data.youtube_handle || '');
        setTwitterHandle(response.data.twitter_handle || '');
        setInstagramHandle(response.data.instagram_handle || '');
        setTiktokHandle(response.data.tiktok_handle || '');
        setSnapchatHandle(response.data.snapchat_handle || '');
        setFacebookHandle(response.data.facebook_handle || '');
        setLinkedinHandle(response.data.linkedin_handle || '');
        setWhatsappNumber(response.data.whatsapp_number || '');
        setSocialContact(response.data.social_contact_platforms || []);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  const saveField = async (name, value) => {
    try {
      await axios.post(
        `${API_URL}/coaches/profile`,
        { [name]: value },
        getAxiosConfig()
      );
      setMessage('Saved');
      setMessageType('');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Auto-save error:', error);
      setMessage('Error saving');
      setMessageType('error');
      setTimeout(() => setMessage(''), 4000);
    }
  };

  const toggleSocialContact = (platform, checked) => {
    setSocialContact(prev => {
      const next = checked ? [...new Set([...prev, platform])] : prev.filter(p => p !== platform);
      saveField('social_contact_platforms', next);   // POST the full array
      return next;
    });
  };

  return (
    <CoachProfileShell activeTab="Social">
      {message && (
        <div className={`settings-toast ${messageType === 'error' ? 'settings-toast--error' : ''}`} role="alert">{message}</div>
      )}

      {/* Personal Statement */}
      <div className="settings-section">
        <h2 className="settings-section__title">Personal Statement</h2>
        <p className="settings-section__desc">Share your coaching philosophy and what you look for in athletes.</p>
        <div className="form-field">
          <label className="form-field__label" htmlFor="personal_statement">Personal Statement</label>
          <textarea
            id="personal_statement"
            value={personalStatement}
            onChange={(e) => setPersonalStatement(e.target.value)}
            onBlur={() => saveField('personal_statement', personalStatement)}
            className="form-field__input"
            rows={5}
            placeholder="Tell others about your coaching experience, philosophy, and what you look for in athletes..."
          />
        </div>
      </div>

      {/* Social Media */}
      <div className="settings-section">
        <h2 className="settings-section__title">Social Media</h2>
        <p className="settings-section__desc">Your social media handles.</p>
        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_youtube">YouTube</label>
            <input
              id="social_youtube"
              type="text"
              value={youtubeHandle}
              onChange={(e) => setYoutubeHandle(e.target.value)}
              onBlur={() => saveField('youtube_handle', youtubeHandle)}
              className="form-field__input"
              placeholder="Channel name or URL"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('youtube')}
                disabled={!youtubeHandle}
                onChange={e => toggleSocialContact('youtube', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_twitter">X / Twitter</label>
            <input
              id="social_twitter"
              type="text"
              value={twitterHandle}
              onChange={(e) => setTwitterHandle(e.target.value)}
              onBlur={() => saveField('twitter_handle', twitterHandle)}
              className="form-field__input"
              placeholder="@username"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('twitter')}
                disabled={!twitterHandle}
                onChange={e => toggleSocialContact('twitter', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_instagram">Instagram</label>
            <input
              id="social_instagram"
              type="text"
              value={instagramHandle}
              onChange={(e) => setInstagramHandle(e.target.value)}
              onBlur={() => saveField('instagram_handle', instagramHandle)}
              className="form-field__input"
              placeholder="@username"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('instagram')}
                disabled={!instagramHandle}
                onChange={e => toggleSocialContact('instagram', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_tiktok">TikTok</label>
            <input
              id="social_tiktok"
              type="text"
              value={tiktokHandle}
              onChange={(e) => setTiktokHandle(e.target.value)}
              onBlur={() => saveField('tiktok_handle', tiktokHandle)}
              className="form-field__input"
              placeholder="@username"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('tiktok')}
                disabled={!tiktokHandle}
                onChange={e => toggleSocialContact('tiktok', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_snapchat">Snapchat</label>
            <input
              id="social_snapchat"
              type="text"
              value={snapchatHandle}
              onChange={(e) => setSnapchatHandle(e.target.value)}
              onBlur={() => saveField('snapchat_handle', snapchatHandle)}
              className="form-field__input"
              placeholder="@username"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('snapchat')}
                disabled={!snapchatHandle}
                onChange={e => toggleSocialContact('snapchat', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_facebook">Facebook</label>
            <input
              id="social_facebook"
              type="text"
              value={facebookHandle}
              onChange={(e) => setFacebookHandle(e.target.value)}
              onBlur={() => saveField('facebook_handle', facebookHandle)}
              className="form-field__input"
              placeholder="Profile name or URL"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('facebook')}
                disabled={!facebookHandle}
                onChange={e => toggleSocialContact('facebook', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
        </div>
        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_linkedin">LinkedIn</label>
            <input
              id="social_linkedin"
              type="text"
              value={linkedinHandle}
              onChange={(e) => setLinkedinHandle(e.target.value)}
              onBlur={() => saveField('linkedin_handle', linkedinHandle)}
              className="form-field__input"
              placeholder="Profile URL"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('linkedin')}
                disabled={!linkedinHandle}
                onChange={e => toggleSocialContact('linkedin', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
          <div className="form-field">
            <label className="form-field__label" htmlFor="social_whatsapp">WhatsApp</label>
            <input
              id="social_whatsapp"
              type="text"
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              onBlur={() => saveField('whatsapp_number', whatsappNumber)}
              className="form-field__input"
              placeholder="+1 (555) 123-4567"
            />
            <label className="cn-check" style={{ marginTop: 4 }}>
              <input type="checkbox"
                checked={socialContact.includes('whatsapp')}
                disabled={!whatsappNumber}
                onChange={e => toggleSocialContact('whatsapp', e.target.checked)} />
              {' '}OK to contact me here
            </label>
          </div>
        </div>
      </div>
    </CoachProfileShell>
  );
}
